import { connect } from 'react-redux'
import { createSelector } from 'reselect'
import StompunktLayer from './StompunktLayer'
import { openStompunkt, toggleStompunkt } from '../../actionCreators'
import { mapColorCategory, coordinates2d, passFilter } from '../../selectors/stompunkt'
import { currentLightStompunktIfCached } from '../../selectors/currentStompunkt'
import { isToZoomedOut } from '../../selectors/latestLoadLightError'
import { groupBy, emptyArrayIfNull } from '../../utils/misc'

const mapStateToProps = (state, ownProps) => ({
	stompunkter: cachedVisibleStompunkter(state),
	markedStompunkter: state.selectedStompunkter,
	showLabels: state.showLabels,
	currentStompunkt: currentLightStompunktIfCached(state)
})

const mapDispatchToProps = (dispatch, ownProps) => ({
	onClick: (id) => dispatch(openStompunkt(id)),
	onShiftClick: (id) => dispatch(toggleStompunkt(id)),
})

const getLightStompunkter = (state) => state.lightStompunkter
const getMapBounds = (state) => state.mapBounds
const getFilter = (state) => state.filter
const getToZoomedOut = isToZoomedOut
const getCurrentStompunkt = (state) => currentLightStompunktIfCached(state);

const cachedVisibleStompunkter = createSelector(
	[getLightStompunkter, getMapBounds, getFilter, getToZoomedOut, getCurrentStompunkt],
	visibleStompunkter
)

function visibleStompunkter(stompunkter, bounds, filter, toZoomedOut, currentStompunkt) {
	if (toZoomedOut) {
		return []
	}
	else {
		const current = currentStompunkt || {id: -1};
		const isVisible = (stompunkt) => insideBounds(stompunkt, bounds) && (passFilter(stompunkt, filter) ||  current.id === stompunkt.id)
		const visibleStompunkter = Object.values(stompunkter).filter(isVisible)
		return sortByStompunktGroup(visibleStompunkter)
	}
}

function insideBounds(stompunkt, bounds) {
	const [coordE, coordN] = coordinates2d(stompunkt)
	return coordE >= bounds.west
		&& coordE <= bounds.east
		&& coordN >= bounds.south
		&& coordN <= bounds.north
}

function sortByStompunktGroup(stompunkter) {
	const groups = groupBy(stompunkter, mapColorCategory)
	return [
		...emptyArrayIfNull(groups.förstörd),
		...emptyArrayIfNull(groups.riksavvägningen),
		...emptyArrayIfNull(groups.rix95),
		...emptyArrayIfNull(groups.sweref)
	]
}

export default connect(mapStateToProps, mapDispatchToProps)(StompunktLayer)



// WEBPACK FOOTER //
// ./src/components/Map/StompunktLayerContainer.js